// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PROFILE_TABS_POSTS = "P\u0159\u00edsp\u011bvky";
export const PROFILE_TABS_PRODUCTS = "Pou\u017e\u00edv\u00e1m";
